import {
  useState,
  useRef,
  useEffect,
  type Dispatch,
  type SetStateAction,
  type DependencyList,
} from "react";

function useDerivedState<S>(
  callback: () => S,
  deps: DependencyList
): [S, Dispatch<SetStateAction<S>>] {
  const ref = useRef(callback);
  ref.current = callback;
  const [state, setState] = useState(() => {
    return ref.current();
  });

  useEffect(() => {
    setState(ref.current());
  }, deps);

  return [state, setState];
}

export default useDerivedState;
